<template>
    <modal v-bind="$attrs" v-on="$listeners" :center="true">
      <template v-slot:body>
        <div>
            <slot name="body"></slot>
        </div>
      </template>
      <template v-slot:footer>
        <primary-button class="confirm-delete" ref="" @click.native="handleContinue">
          {{ $t('common.continue') }}
        </primary-button>
        <tertiary-button class="confirm-cancel" @click.native="$emit('closed')">
          {{ $t('common.cancel') }}
        </tertiary-button>
      </template>
    </modal>
  </template>
  
  <script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  
  export default {
    props: {
      modalTitle: {},
      modalDesc: {}
    },
    components: {
      Modal,
      PrimaryButton,
      TertiaryButton
    },
    computed: {
    },
    methods: {
      handleContinue() {
        this.$emit('closed');
        this.$emit('continute');
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  @import '../../../scss/_colors.scss';

.elsa-button.continue,
.elsa-button.continue:hover {
    font-size: 16px;
    border-radius: 8px;
    padding-left: 16px;
    padding-right: 16px;
}

.elsa-button.cancel {
  padding: 0 16px;
  font-size: 16px;
}



::v-deep {
  .el-dialog.elsa-modal {
    .el-dialog__header,
    .el-dialog__body {
      //padding: 40px 40px 0 40px;
      // display: flex;
      background-color: white;
    }

    &.signup .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      min-height: 27.5px;
    }

    .el-dialog__body {
      border-top: none;
      & > *:not(p):not(.info) {
        padding-bottom: 6px;
        display: flex;
        flex-direction: column;
      }
    }

    .el-dialog__footer {
      padding: 0 20px 48px 20px;
      justify-content: center;
    }
  }
}
  </style>
  